import Data from '@iez/lib/data/'

const production = process.env.NODE_ENV !== `development`
const stripeKeyTest = `pk_test_TYooMQauvdEDq54NiTphI7jx`
const stripeKeyDefault = `pk_live_51IUHhiEoFDGdKhOw6wsAxEbQrX9swbXeKqYhWEPE7TtzA6aeF0CL7CpB0GtBEPSWsIHFuE4beF6qecPuG8NMgMsf004nOec172`
const stripeKey = production ? stripeKeyDefault : stripeKeyTest

Data.init({
  firebaseConfig: {
    apiKey: 'AIzaSyCJ_T6d43Vq22KCbqrMpC2NUfrcgTC5mFM',
    authDomain: 'iez-yako.firebaseapp.com',
    databaseURL: 'https://iez-yako.firebaseio.com',
    projectId: 'iez-yako',
    storageBucket: 'iez-yako.appspot.com',
    messagingSenderId: '629590475371',
    appId: '1:629590475371:web:cf4e18880b174e8dde272e',
    measurementId: 'G-ZMBE3Z76D5'
  },
  project: 'iez-yako',
  stripeKey
})
